import React from "react";
import { Tag } from "antd";
import { ExporterPortPairUploadedStatus } from "../../util/Constant";


const statusDetails = {
  [ExporterPortPairUploadedStatus.FAILED]: {
    label: "Failed",
    color: "#FF0000",
  },
  [ExporterPortPairUploadedStatus.UPLOADED]: {
    label: "Uploaded",
    color: "#008000",
  },
  [ExporterPortPairUploadedStatus.PROCESSING]: {
    label: "Processed",
    color: "#F5993F",
  },
};

const ExporterPortPairUploadStatus = ({ status }) => {
  return (
    <div>
      <Tag color={statusDetails[status]?.color}>
        {statusDetails[status]?.label}
      </Tag>
    </div>
  );
};

export default ExporterPortPairUploadStatus;
